// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__2nd1W","icon":"SortAdornment_icon__1OEyj","up":"SortAdornment_up__1pr31","down":"SortAdornment_down__1quoy","active":"SortAdornment_active__3h0t-"};